export default __webpack_public_path__ + "static/media/speedometer.e9209e8f.svg";